export default __webpack_public_path__ + "static/media/change_password_header.df4867dc.png";